import Vue, { VueConstructor } from 'vue'
import Layout from '@/layouts/Public.vue'
import Login from '@/views/public/LoginAdmin.vue'
import NotFound from '@/views/public/NotFound.vue'
import ForgotPassword from '../../views/public/ForgotPassword.vue'
import WebPage from '../../views/public/WebPage.vue'

const routes = [
    {
        path: '/',
        name: 'WebPage',
        component: WebPage // ← carga directo, sin Layout
    },
    {
        path: '/manager',
        component: Layout as VueConstructor<Vue>,
        meta: { auth: 'public' },
        children: [
            {
                path: 'login',
                name: 'Login',
                meta: { auth: 'public' },
                component: Login
            },
            {
                path: 'forgot-password',
                name: 'ForgotPassword',
                meta: { auth: 'public' },
                component: ForgotPassword
            }
        ]
    },
    { path: '/404', component: NotFound },
    { path: '*', redirect: '/404' }
]
export default routes
